import { Directive, ElementRef, HostBinding, Renderer2 } from '@angular/core';

@Directive({
  selector: '[errorMessage]',
})
export class ErrorMessageDirective {
  @HostBinding('class') elementClass = 'paragraph-02-bold';
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}
  ngOnInit() {
    this.renderer.setStyle(this.el.nativeElement, 'color', '#ba342b');
  }
}
